/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon,
    DOMAIN_CURRENT
} = Ajax;
const TheApi = API('comment');
const COMMENT_LIST_V2 = "COMMENT_LIST_V2";
const COMMENT_EDIT = "COMMENT_EDIT";
const COMMENT_ADD_V2 = "COMMENT_ADD_V2";
const COMMENT_DELETE = "COMMENT_DELETE";
const COMMENT_SENSIVE = "COMMENT_SENSIVE";
const COMMENT_MAKE_TOP = "COMMENT_MAKE_TOP";
const COMMENT_CANCEL_TOP = "COMMENT_CANCEL_TOP";
const COMMENT_EXPORT_V2 = "COMMENT_EXPORT_V2";

export default {
    COMMENT_EXPORT_V2,
    commentV2Export: (galleryid, filter, email)=>{
      return ajaxCommon({
          data:{
            ...filter,
            email
          },
          api:{
            method:'GET',
            url:`${DOMAIN_CURRENT}/api/comment/export/${galleryid}`,
          },
          success: (res)=>{
            return {
                type:COMMENT_EXPORT_V2,
                data:res
            };
          }
      })
    },
    COMMENT_LIST_V2,
    commentV2List : (galleryid, filter, page)=>{
        return ajaxCommon({
            data:{
              page,
              ...filter
            },
            api:{
              method:'GET',
              url:`${DOMAIN_CURRENT}/api/v2/comments/${galleryid}/crmlist`,
            },
            success: (res)=>{
              return {
                  type:COMMENT_LIST_V2,
                  data:res
              };
            }
        })
    },
    COMMENT_ADD_V2,
    commentV2Add:(data)=>{
        return ajaxCommon({
            data:data,
            api:{
              method:'POST',
              url:`${DOMAIN_CURRENT}/api/v2/comments/add`,
            },
            success: (res)=>{
              return {
                  type:COMMENT_ADD_V2,
                  data:res
              };
            }
        })
    },
    COMMENT_EDIT,
    commentEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:COMMENT_EDIT,
                data,
            })
        })
    },
    COMMENT_SENSIVE,
    commentSensive:(word)=>{
        return ajaxCommon({
            api:TheApi('post')('sensive'),
            data:{
                word
            },
            success:(data)=>({
                type:COMMENT_SENSIVE,
                data
            })
        })
    },
    COMMENT_DELETE,
    commentDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:COMMENT_DELETE,
                id,
                data
            })
        })
    },
    COMMENT_MAKE_TOP,
    commentMakeTop:(id)=>
        ajaxCommon({
            api:TheApi('post')('maketop'),
            data: {
                id,
            },
            success:()=>({
                type: COMMENT_MAKE_TOP,
            })
        }),
    COMMENT_CANCEL_TOP,
    commentCancelTop:(id)=>
        ajaxCommon({
            api:TheApi('post')('canceltop'),
            data: {
                id,
            },
            success:()=>({
                type: COMMENT_MAKE_TOP,
            })
        }),
}



// WEBPACK FOOTER //
// ./src/actions/CommentV2Action.js